<script>
  export default {
    name: 'll-custom-render',
    props: {
      render: {
        type: Function,
        required: true,
      },
    },

    setup(props) {
      return () => props.render();
    },
  };
</script>
